import { useEffect, useState } from 'react';
import { Box, FormControl, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useApi } from '@backstage/core-plugin-api';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const PlatformHostField = ({
  onChange,
  rawErrors,
  required,
  formData,
  uiSchema,
  formContext,
}: FieldExtensionComponentProps<any>) => {
  const catalogApi = useApi(catalogApiRef);

  const architectureType =
    formContext?.formData?.architectureType;

  const platformHostRequired =
    architectureType === 'platform_application';

  console.log('[PlatformHostField] architectureType', architectureType);

  // const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // const abortControllerRef = useRef<AbortController | null>(null);

  const label: string = String(uiSchema['ui:options']?.label || 'User');

  const [users, setUsers] = useState<any[]>([]);
  const [userRef, setUserRef] = useState('');

  useEffect(() => {

    if (!formData) return;
    console.log(formData);
    setUserRef(formData || '');
  }, [formData]);

  useEffect(() => {
    if (architectureType !== 'platform_application') {
      setUserRef('');
      onChange(undefined);
    }
  }, [architectureType]);

  useEffect(() => {
    const loadInitialApplications = async () => {
      try {
        console.log(
          '[PlatformHostField] loading initial applications',
        );

        const items = await fetchPlatformHosts();

        console.log(
          '[PlatformHostField] initial applications',
          items?.length,
        );

        setUsers(items);
      } catch (e) {
        console.error(
          '[PlatformHostField] initial load error',
          e,
        );
      }
    };

    loadInitialApplications();
  }, []);

  const fetchPlatformHosts = async () => {
    const response = await catalogApi.getEntities({
      filter: {
        kind: 'Application',
        'spec.architectureType': 'Host de la Plataforma',
      },
    });

    const applications = response.items;

    // const applications = response.items.filter(entity => {

    //   const search = query.toLowerCase();

    //   return (
    //       entity.metadata?.name
    //         ?.toLowerCase()
    //         .includes(search) ||

    //       entity.metadata?.title
    //         ?.toLowerCase()
    //         .includes(search) ||

    //       (entity.spec?.number as string)
    //         ?.toLowerCase()
    //         .includes(search)
    //   );
    // });

    return applications;
  };

  // const handleSearchInput = (query: string) => {
  //   if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
  //   if (abortControllerRef.current) abortControllerRef.current.abort();

  //   if (query.trim().length < 3) {
  //     setUsers([]); // limpia buffer si < 3 letras
  //     return;
  //   }

  //   searchTimeoutRef.current = setTimeout(async () => {
  //     try {
  //       const items = await fetchPlatformHosts(query);
  //       setUsers(items);  // solo reemplaza buffer, MUI mantiene foco
  //     } catch (e: any) {
  //       if (e.name === 'AbortError') return;
  //       console.error('[PTM] fetchCatalogUsersPage error', e);
  //       setUsers([]);
  //     }
  //   }, 300);
  // };

  // -----------------------------------------------------------------------------------
  // ✔️ Render
  // -----------------------------------------------------------------------------------
  return (
    <FormControl margin="normal" required={required} fullWidth>
      <Autocomplete
        options={users}
        getOptionLabel={opt =>
          `${opt?.spec?.number} - ${opt?.metadata?.title || opt?.metadata?.name}`
        }
        // filterOptions={(x) => x}      // desactiva filtro interno
        // onInputChange={(_, value, reason) => {
        //   if (reason !== 'input') return;
        //   handleSearchInput(value);   // debounce + mínimo 3 letras
        // }}
        clearOnBlur={false}          // no borrar texto al perder foco
        blurOnSelect={false}         // no perder foco al seleccionar
        openOnFocus                  // mantiene dropdown abierto
        value={
          users.find(
            p => stringifyEntityRef(p) === userRef,
          ) || null
        }
        onChange={(_, newValue) => {
          if (newValue) onChange(stringifyEntityRef(newValue));
        }}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            required={platformHostRequired}
            error={
              platformHostRequired &&
              !userRef
            }
            helperText={
              platformHostRequired && !userRef
                ? 'Platform Host is required when Architecture Type is Platform Application'
                : rawErrors?.[0] ||
                `Select the ${label.toLowerCase()}`
            }
          />
        )}
        renderOption={(option) => (
          <Box>
            <Typography variant="body2">
              {option?.spec?.number} - {option?.metadata?.title || option?.metadata?.name}
            </Typography>

            <Typography variant="caption" color="textSecondary">
              {option?.metadata?.description || ''}
            </Typography>
          </Box>
        )}
      />
    </FormControl>
  );
};

// -----------------------------------------------------------------------------------
// ✔️ Validación
// -----------------------------------------------------------------------------------
import type { FieldValidation } from '@rjsf/utils';

export const platformHostCaseValidation = (
  value: string,
  validation: FieldValidation,
  context: any,
) => {
  console.log(
    '[PlatformHostField] validation start',
    {
      value,
      context,
    },
  );
  const architectureType =
    context?.formContext?.formData?.architectureType ??
    context?.formData?.architectureType;

  console.log(
    '[PlatformHostField] validation',
    {
      value,
      architectureType,
    },
  );

  if (
    architectureType === 'platform_application' &&
    !value
  ) {
    validation.addError(
      'Platform Host is required when Architecture Type is Platform Application',
    );
  }
};

// -----------------------------------------------------------------------------------
// ✔️ Registro del Custom Field
// -----------------------------------------------------------------------------------
export const PlatformHostCaseFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PlatformHostField',
    component: PlatformHostField,
    validation: platformHostCaseValidation,
  }),
);
